import timeTrackingThumbnail from "../assets/images/designs thumbnails/timeTrackingThumbnail.jpg";
import articleThumbnail from "../assets/images/designs thumbnails/articleThumbnail.jpg";
import baseApparelThumbnail from "../assets/images/designs thumbnails/baseApparelThumbnail.jpg";
import coolloginThumbnail from "../assets/images/designs thumbnails/coolloginThumbnail.jpg";
import comingsoonThumbnail from "../assets/images/designs thumbnails/comingsoonThumbnail.jpg";
import fourcardThumbnail from "../assets/images/designs thumbnails/fourcardThumbnail.jpg";
import faqaccordionThumbnail from "../assets/images/designs thumbnails/faqaccordionThumbnail.jpg";
import huddleThumbnail from "../assets/images/designs thumbnails/huddleThumbnail.jpg";
import introsignupThumbnail from "../assets/images/designs thumbnails/introsignupThumbnail.jpg";
import nftThumbnail from "../assets/images/designs thumbnails/nftThumbnail.jpg";
import qrThumbnail from "../assets/images/designs thumbnails/qrcodeThumbnail.jpg";
import profileCardThumbnail from "../assets/images/designs thumbnails/profilecardThumbnail.jpg";
import orderSummaryThumbnail from "../assets/images/designs thumbnails/ordersummaryThumbnail.jpg";
import socialProofThumbnail from "../assets/images/designs thumbnails/socialproofThumbnail.jpg";
import statsPreviewThumbnail from "../assets/images/designs thumbnails/statspreviewThumbnail.jpg";
import sunnysideThumbnail from "../assets/images/designs thumbnails/sunnysideThumbnail.jpg";
import threeColumnThumbnail from "../assets/images/designs thumbnails/threecolumnThumbnail.jpg";
import orkaThumbnail from "../assets/images/designs thumbnails/orkaThumbnail.jpg";

const DESIGNS_BASE_URL = "https://kralmarko123.github.io/frontend-portfolio";

export const DESIGNS = [
  {
    title: "Time Tracking Dashboard",
    link: `${DESIGNS_BASE_URL}/time-tracking-dashboard-main/index.html`,
    thumbnail: timeTrackingThumbnail,
  },

  {
    title: "Base Apparel",
    link: `${DESIGNS_BASE_URL}/baseApparelComingSoonMaster/index.html`,
    thumbnail: baseApparelThumbnail,
  },

  {
    title: "Article Preview",
    link: `${DESIGNS_BASE_URL}/articlePreviewComponentMaster/index.html`,
    thumbnail: articleThumbnail,
  },

  {
    title: "Cool Login Form",
    link: `${DESIGNS_BASE_URL}/coolLoginForm/index.html`,
    thumbnail: coolloginThumbnail,
  },

  {
    title: "Ping Coming Soon",
    link: `${DESIGNS_BASE_URL}/pingComingSoonPage/index.html`,
    thumbnail: comingsoonThumbnail,
  },

  {
    title: "Four Card Feature",
    link: `${DESIGNS_BASE_URL}/fourCardFeatureSectionMaster/index.html`,
    thumbnail: fourcardThumbnail,
  },

  {
    title: "Faq Accordion",
    link: `${DESIGNS_BASE_URL}/faqAccordionCardMain/index.html`,
    thumbnail: faqaccordionThumbnail,
  },

  {
    title: "Huddle Landing",
    link: `${DESIGNS_BASE_URL}/huddleLandingPage/index.html`,
    thumbnail: huddleThumbnail,
  },

  {
    title: "Intro Signup Form",
    link: `${DESIGNS_BASE_URL}/introComponentWithSignupForm/index.html`,
    thumbnail: introsignupThumbnail,
  },

  {
    title: "NFT Component",
    link: `${DESIGNS_BASE_URL}/nft-preview-card-component-main/index.html`,
    thumbnail: nftThumbnail,
  },

  {
    title: "QR Code Component",
    link: `${DESIGNS_BASE_URL}/qr-code-component-main/index.html`,
    thumbnail: qrThumbnail,
  },

  {
    title: "Profile Card Component",
    link: `${DESIGNS_BASE_URL}/profileCardComponent/index.html`,
    thumbnail: profileCardThumbnail,
  },

  {
    title: "Order Summary",
    link: `${DESIGNS_BASE_URL}/orderSummaryComponent/index.html`,
    thumbnail: orderSummaryThumbnail,
  },

  {
    title: "Social Proof",
    link: `${DESIGNS_BASE_URL}/socialProofSectionMaster/index.html`,
    thumbnail: socialProofThumbnail,
  },

  {
    title: "Stats Preview",
    link: `${DESIGNS_BASE_URL}/statsPreviewCardComponent/index.html`,
    thumbnail: statsPreviewThumbnail,
  },

  {
    title: "Sunnyside Agency",
    link: `${DESIGNS_BASE_URL}/sunnyside-agency-landing-page-main/sunnyside-agency-landing-page-main/index.html`,
    thumbnail: sunnysideThumbnail,
  },

  {
    title: "Three Column Preview",
    link: `${DESIGNS_BASE_URL}/threeColumnPreviewComponent/index.html`,
    thumbnail: threeColumnThumbnail,
  },

  {
    title: "Orka Menu",
    link: `http://orka.mk/`,
    thumbnail: orkaThumbnail,
  },
];
